/**
 * The emails sent to one customer and what became of them (#3787), on the
 * person and company detail pages. The server resolves the customer's own
 * addresses; the section shows only to staff who may read customers.
 */
import { useTranslation } from 'react-i18next';
import { DetailSection } from '@/components/common/DetailSection';
import { PermissionGuard } from '@/components/common/PermissionGuard';
import { EmailDeliveryHistory } from './EmailDeliveryHistory';

interface CustomerEmailDeliverySectionProps {
  customerType: 'person' | 'company';
  customerId: string;
}

export function CustomerEmailDeliverySection({ customerType, customerId }: CustomerEmailDeliverySectionProps) {
  const { t } = useTranslation('common');
  return (
    <PermissionGuard permission="customers.read">
      <DetailSection title={t('emailDelivery.customerTitle')}>
        <EmailDeliveryHistory entityType={customerType} entityId={customerId} hideTitle />
      </DetailSection>
    </PermissionGuard>
  );
}
